import currencies from './currencySymbols.json';

export const useFormatPrice = (currency: string) => {
  const formatPrice = (price: number, currencyCode = currency || '') => {
    const symbol = currencies[currencyCode as keyof typeof currencies];
    const sign = price < 0 ? '-' : '';

    const formattedPrice = Math.abs(price).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    return `${sign}${symbol}${formattedPrice} ${currencyCode}`.trim();
  };

  return formatPrice;
};
